import { ArchiveAPIResources, Date } from '../components/RawData/model'
import { isARMHybridDetail, Resource } from '../common/resource/model'
import RemoteApi from './BaseRemoteApi'

export default class ArchiveAPIService extends RemoteApi {

  constructor(authorization: string) {
    const dns = ArchiveAPIService.getQueryRouterDNS()

    super(`${dns}/monitoring/archive/api/v1`, authorization)

    this.fetchLogFiles = this.fetchLogFiles.bind(this)
    this.fetchHybridLogFiles = this.fetchHybridLogFiles.bind(this)
    this.fetchS3FolderNames = this.fetchS3FolderNames.bind(this)
  }

  fetchLogFiles(orgId: string, envId: string, logResourceId: string, date: Date): Promise<ArchiveAPIResources> {
    return this._post(['organizations', orgId,
        'environments', envId,
        'applications', logResourceId,
        'logs', date.year, date.month, date.day
    ],                undefined, true)
  }

  fetchHybridLogFiles(orgId: string, envId: string, logResourceId: string, date: Date): Promise<ArchiveAPIResources> {
    return this._post(['organizations', orgId,
      'environments', envId,
      'servers', logResourceId,
      'logs', date.year, date.month, date.day
    ],                undefined, true)
  }

  fetchS3FolderNames(orgId: string, envId: string, resource: Resource): Promise<ArchiveAPIResources> {
    if (isARMHybridDetail(resource)) {
        return this._post(['organizations', orgId,
                           'environments', envId,
                           'servers'], undefined, true)
        }


    return this._post(['organizations', orgId,
                       'environments', envId,
                       'applications'], undefined, true)
  }


  static getQueryRouterDNS() {
    if (window.mc && window.mc.queryRouter) {
      return window.mc.queryRouter.dns || ''
    } else {
      return ''
    }
  }

}
